import React, { useContext, useEffect } from "react";
import PropTypes from "prop-types";
import { useObjectSettings } from "./contexts/ObjectSettingsProvider";

const SidebarContext = React.createContext();

const SidebarIds = {
  object: "object",
  artworkInfo: "artwork-info"
};

export function SidebarContextProvider({ children, sidebarId, setSidebar }) {
  const { handleSelectedObject } = useObjectSettings();

  useEffect(() => {
    const handleArtworkInfo = e => {
      handleSelectedObject(e);
      setSidebar(SidebarIds.artworkInfo);
    };

    window.addEventListener("open-artwork-info", e => handleArtworkInfo(e));
    // open-artwork-info
    window.addEventListener("open-object-settings", () => setSidebar(SidebarIds.object));
    window.addEventListener("close-object-settings", () => setSidebar(null));
    return () => {
      window.removeEventListener("open-object-settings", () => setSidebar(SidebarIds.object));
      window.removeEventListener("open-artwork-info", e => handleArtworkInfo(e));
      window.removeEventListener("close-object-settings", () => setSidebar(null));
    };
  }, [handleSelectedObject, setSidebar]);

  return <SidebarContext.Provider value={{ sidebarId, setSidebar }}>{children}</SidebarContext.Provider>;
}

export function useSidebarContext() {
  return (
    useContext(SidebarContext) || {
      sidebarId: "",
      setSidebar: () => {}
    }
  );
}

SidebarContextProvider.propTypes = {
  children: PropTypes.node,
  sidebarId: PropTypes.string,
  setSidebar: PropTypes.func
};
